import React, { useEffect, useState } from 'react';
import { Sidebar, Header, CustomSelect, LoadingPage } from '../common';
import { CustomDatePicker, InputBox } from './common/';
import { BillTable } from './tables';
import { getAllUser, getAllBuilding, getUtilities, getBilling, getSnapshotDate, saveSnapshot, saveUtilities} from "./ApiService";
import WarningLoginModal from '../buildingPages/modals/WarningLoginModal';

import ExclamationCircleIcon from "./assets/exclamation-circle.svg";
import DownloadNormal from './assets/download-normal.svg';
import Uploading from "./assets/uploading.svg"
import UploadComplete from "./assets/upload-complete.svg"

import { pdf, PDFViewer } from '@react-pdf/renderer';
import PDFDocument from './PDFDocument';

import '../styles/styles.css';
import './Bill.css';

const Bill = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 7);
    const [date, setDate] = useState(formattedDate);
    const [allowedMonths, setAllowedMonths] = useState([formattedDate]);

    const [isUploading, setIsuploading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

    const role = sessionStorage.getItem("role");
    const [users, setUsers] = useState(sessionStorage.getItem("userName"));
    const [userId, setUserId] = useState("");

    const buildingData = JSON.parse(sessionStorage.getItem("building")) || [];
    const [buildings, setBuildings] = useState(buildingData.reduce((acc, item) => {
        acc[item.id] = item.buildingName;
        return acc;
    }, {}));
    const [buildingId, setBuildingId] = useState(sessionStorage.getItem("lastBuilding") || Object.keys(buildings)[0] ||  null);
    const hasBuilding = buildingId !== null;

    const [PDFData, setPDFData] = useState({});
    const [beforeSaveTableData, setBeforeSaveTableData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [tableBuildingData, setTableBuildingData] = useState({});
    const errorTableData = [{ roomId: -1 }]
    
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectItem, setSelectItem] = useState([]);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1 필요
        const day = String(date.getDate()).padStart(2, '0');
        
        const weekDays = ['일', '월', '화', '수', '목', '금', '토'];
        const weekDay = weekDays[date.getDay()];
    
        return `${year}.${month}.${day}(${weekDay})`;
    };

    const updateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
    
        const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      
        return formattedTime;
    };

    const handleOpenPdf = async ({ roomId }) => {
        if (role !== "USER" && role !== "ADMIN") {
            setIsWarningModalOpen(true);
            return;
        }

        const today = new Date();

        const userName = sessionStorage.getItem("userName")
        const date = formatDate(today)
        const buildingName = tableBuildingData.buildingName
        let roomInfo;
        if (roomId === 0) {
            roomInfo = tableData.filter(item => checkedItems.includes(item.roomId));
        } else {
            roomInfo = tableData.filter(item => roomId === item.roomId)
        }

        const blob = await pdf(<PDFDocument userName={userName} date={date} buildingName={buildingName} room={roomInfo} />).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
    };

    const generateTableData = (billData) => {
        const roomList = billData;
        return {
            roomUtilitiesInfoList : roomList,
        }
    }
    
    const resentPDFDownload = (roomId, inputValue) => {
        setTableData(prevData =>
            prevData.map(room =>
                room.roomId === roomId
                    ? {...room, lastPDFDownload: inputValue}
                    : room
            )
        )
        handleOpenPdf({ roomId })
    };

    const roomsPDFDownload = () => {
        if (checkedItems.length === 0) {
            alert("호실을 1개 이상 선택해주세요.");
            return;
        }
        const rooms = checkedItems
        const update = updateTime()

        setTableData(prevData =>
            prevData.map(room =>
                rooms.includes(room.roomId)
                    ? { ...room, lastPDFDownload: update }
                    : room
            )
        );
        handleOpenPdf({ roomId: 0 });
    }

    useEffect(() => {
        if (role === "ADMIN") {
            getAllUser(setUsers)
        }
    }, [])

    useEffect(() => {
        if (role === "ADMIN") {
            getAllBuilding(userId, buildings, setBuildings, setBuildingId);
        }
    }, [userId, buildings])

    useEffect(() => {
        const generatedData = generateTableData(tableData)
        
        if (JSON.stringify(tableData) !== JSON.stringify(errorTableData)) {
            if (JSON.stringify(generatedData) !== JSON.stringify(beforeSaveTableData)) {
                setBeforeSaveTableData(generatedData); 
                setTableData(generatedData.roomUtilitiesInfoList);    
                
                setIsuploading(true);

                const handleSaveSnapshot = async () => {
                    await saveSnapshot(date, buildingId, generatedData, "bill");
                };
                handleSaveSnapshot()
                    .then(() => {
                        setIsuploading(false);
                    })
                    .catch(error => {
                        // console.log("저장중 에러발생: ", error);
                        setIsuploading(false);
                    });
            }
        }
    }, [tableData]);

    // buildingId와 date로 서버에서 데이터 불러오기
    useEffect(() => {
        getBilling(buildingId, date, setIsLoading, setTableData, setTableBuildingData);
    }, [buildingId, date])

    useEffect(() => {
        getSnapshotDate(buildingId, setAllowedMonths);
    }, [buildingId]);

    if (isLoading) {
        return <LoadingPage />;
    }
    return(
        <div className="page">
            <Sidebar />
            <div className="sideBarElseContainer">
                <Header pageName="청구"/>
                <div className="headerElseContainer">
                    <div className="billingPageContainer">
                        <div className="billingPageLeftContainer">
                            {role === "ADMIN" ? (
                                <CustomSelect placeholder="사용자를 선택해주세요" customSelectList={users} parentCustomSelect={userId} setParentCustomSelect={setUserId} />
                            ) : (<></>)}
                            <CustomSelect placeholder="건물을 선택해주세요" customSelectList={buildings} parentCustomSelect={buildingId} setParentCustomSelect={setBuildingId} />
                            <div className="saving-status-container">
                                {isUploading ? (
                                    <div className="uploading-status-container">
                                        <img src={Uploading} alt="uploading" className='uploading' />
                                        <span className="uploadingSpan">
                                            저장중...
                                        </span>
                                    </div>
                                ) : (
                                    <div className="upload-complete-status-container">
                                        <img src={UploadComplete} alt="upload-complete" className="uploadComplete"/>
                                        <span className="uploadCompleteSpan">
                                            저장완료!
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <CustomDatePicker placeholder="년월을 선택해주세요" allowedMonths={allowedMonths} date={date} setDate={setDate} />
                    </div>
                    <div className='billingBtmContainer'>
                        <div className='billingBtmInfo'>
                            {sessionStorage.getItem("role") === "GUEST" ? (
                                <div className="billingBtmInfoExplain">
                                    <img src={ExclamationCircleIcon} alt="Information" className='exclamationCircle' />
                                    로그인하시면 계산 내용을 저장할 수 있습니다.
                                </div>
                            ) : (<div></div>)}
                            <div className='버튼2개'>
                                {/* <button className="downloadButton csvDownloadButton">
                                    <img src={DownloadNormal} className='downloadNormal' />
                                    CSV 다운로드
                                </button> */}
                                <button className="downloadButton" onClick={roomsPDFDownload}>
                                    <img src={DownloadNormal} className='downloadNormal' />
                                    호실별 합산 PDF 다운로드
                                </button>
                            </div>
                        </div>
                        <div className="billingRoomCalculator">
                            <BillTable hasBuilding={hasBuilding} roomInfo={tableData || []} setRoomInfo={resentPDFDownload} setParentCheckedItems={setCheckedItems} />
                        </div>
                    </div>
                    <WarningLoginModal
                        isOpen={isWarningModalOpen}
                        message="PDF를 다운로드하려면 로그인이 필요해요"
                        onClose={() => setIsWarningModalOpen(false)}
                    />
                </div>
            </div>
        </div>
    );
};

export default Bill;